var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"100%"}},[_c('iframe',{staticStyle:{"overflow":"auto"},attrs:{"id":"prev-docs","type":"application/pdf","width":"100%","height":"525"}})])
}]

export { render, staticRenderFns }